import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { ConceptsOpenService } from '@shared/factories/concepts-open/concepts-open.service';
import { ApiServiceService } from '@shared/services/api-service/api-service.service';

@Injectable({
  providedIn: 'root'
})

export class ConceptObjectResolver  {
    constructor(private apiService: ApiServiceService,
      private conceptsOpenService: ConceptsOpenService
    ) { }
    resolve(route: ActivatedRouteSnapshot) {
      let conceptObjectId = route.params['conceptObjectId'];
      if(!conceptObjectId){
          let logInfoStorage: any = sessionStorage.getItem('loginInfo');
          let loginInfo = JSON.parse(logInfoStorage.split('/'));
          if(loginInfo?.target?.targetType === 'ConceptObject'){
              conceptObjectId = loginInfo.target.targetId;
          }
      }
      return this.apiService.get('conceptobjects', conceptObjectId)
        .then((data:any)=>{
          this.conceptsOpenService.deleteAllConceptsOpen();
          return data
        })
    }

}
